import { useCallback } from 'react';
import { Text, UnstyledButton } from '@mantine/core';
import { ArrowRight, Sparkle } from 'lucide-react';
import { useVibeModeDockAvailability } from '@/modules/VibeMode/hooks/useVibeModeDockAvailability';
import { useVibeModeDockCommand } from '@/modules/VibeMode/hooks/useVibeModeDockCommand';
import { VibeModeDockIntent } from '@/modules/VibeMode/vibe-mode-dock.contract';

interface AskVibeModeSearchCardProps {
    query: string;
}

const AskVibeModeSearchCard = ({ query }: AskVibeModeSearchCardProps) => {
    const { isDockAvailable } = useVibeModeDockAvailability();
    const emitDockCommand = useVibeModeDockCommand();

    const prompt = `I'm searching for the "${query}" in the attributes.`;

    const handleClick = useCallback(() => {
        emitDockCommand({
            intent: VibeModeDockIntent.AskVibeMode,
            payload: { prompt }
        });
    }, [emitDockCommand, prompt]);

    if (!isDockAvailable) {
        // eslint-disable-next-line unicorn/no-null
        return null;
    }

    return (
        <UnstyledButton
            className="group flex w-full items-start gap-3 rounded-lg border-2 border-solid border-gray-2 bg-gray-2 p-4 text-left hover:border-[#a06bff]/50 hover:bg-[#F6F1FF]"
            data-testid="attributes-ask-vibe-mode-card"
            onClick={handleClick}
        >
            <Sparkle className="mt-0.5 shrink-0 text-[#a06bff]" />
            <div className="flex flex-col gap-1">
                <Text className="font-semibold text-sm">
                    Ask Vibe Mode: {prompt}
                </Text>
                <Text className="text-gray-6 text-xs">
                    Ask Vibe Mode to help you find or configure the attribute
                    you need.
                </Text>
            </div>
            <ArrowRight className="ml-auto shrink-0 self-center text-[#a06bff] text-xl transition-transform group-hover:translate-x-1" />
        </UnstyledButton>
    );
};

export default AskVibeModeSearchCard;
